/*
 * Minimum Order Quantity (MOQ) — live enforcement + progress UI.
 *
 * Rules come from `window.MOQ_RULES` ({ "<product_id>": <minimum> }), populated by
 * snippets/moq-config.liquid (cart products) and sections/main-product.liquid
 * (the current product). The minimum is the COMBINED quantity across all variants
 * of a product, so a shopper can mix colours to reach it.
 *
 * Server-side Liquid already renders the cart bar and disables the Checkout button on
 * page load (works without JS). This script keeps everything in sync as the cart
 * changes via AJAX (quantity edits, add-to-cart, the notification popup).
 */
(function () {
  'use strict';

  function rules() {
    return window.MOQ_RULES || {};
  }

  function hasRules() {
    return Object.keys(rules()).length > 0;
  }

  function cartJsUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base.replace(/\/$/, '') + '.js';
  }

  function fetchCart() {
    return fetch(cartJsUrl(), { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return null;
      });
  }

  // Returns { blocked, entries: [{ pid, min, qty, needed }] }
  function computeStatus(cart) {
    var r = rules();
    var result = { blocked: false, entries: [] };
    var totals = {};

    if (cart && cart.items) {
      cart.items.forEach(function (item) {
        var pid = String(item.product_id);
        if (!r[pid]) return;
        totals[pid] = (totals[pid] || 0) + item.quantity;
      });
    }

    Object.keys(r).forEach(function (pid) {
      var min = r[pid];
      var qty = totals[pid] || 0;
      var needed = Math.max(0, min - qty);
      result.entries.push({ pid: pid, min: min, qty: qty, needed: needed });
      // Only block when the product is actually in the cart but below its minimum.
      if (qty > 0 && needed > 0) result.blocked = true;
    });

    return result;
  }

  function barHTML(entry, context) {
    var pct = entry.min > 0 ? Math.min(100, Math.round((entry.qty / entry.min) * 100)) : 0;
    var done = entry.qty > 0 && entry.needed <= 0;
    var label;

    if (done) {
      label = '✓ Minimum order of ' + entry.min + ' reached — you can check out.';
    } else if (context === 'product') {
      label =
        'Minimum order: ' +
        entry.min +
        ' (mix any colour). You have ' +
        entry.qty +
        ' in your cart — add ' +
        entry.needed +
        ' more to check out.';
    } else {
      label = 'Minimum order: ' + entry.min + ' (mix any colour). Add ' + entry.needed + ' more to check out.';
    }

    return (
      '<div class="moq-bar' +
      (done ? ' is-complete' : '') +
      '">' +
      '<div class="moq-bar__track"><div class="moq-bar__fill" style="width:' +
      pct +
      '%"></div></div>' +
      '<p class="moq-bar__label">' +
      label +
      ' <span class="moq-bar__count">' +
      entry.qty +
      ' / ' +
      entry.min +
      '</span></p>' +
      '</div>'
    );
  }

  function toggleCheckoutButtons(blocked) {
    var checkout = document.getElementById('checkout');
    if (checkout) {
      checkout.disabled = blocked;
      checkout.classList.toggle('moq-disabled', blocked);
    }

    document.querySelectorAll('.cart__dynamic-checkout-buttons, #dynamic-checkout-cart').forEach(function (el) {
      el.classList.toggle('moq-hidden', blocked);
    });

    var notifForm = document.getElementById('cart-notification-form');
    if (notifForm) {
      var btn = notifForm.querySelector('button');
      if (btn) {
        btn.disabled = blocked;
        btn.classList.toggle('moq-disabled', blocked);
      }
    }
  }

  function updateProductNotice(status) {
    var el = document.querySelector('.moq-notice--product');
    if (!el) return;

    var pid = String(el.getAttribute('data-product-id'));
    var min = parseInt(el.getAttribute('data-moq-min'), 10) || 0;
    var entry = status.entries.filter(function (e) {
      return e.pid === pid;
    })[0] || { pid: pid, min: min, qty: 0, needed: min };

    el.classList.toggle('is-complete', entry.qty > 0 && entry.needed <= 0);
    el.innerHTML = barHTML(entry, 'product');
  }

  function updateNotification(status) {
    var notif = document.getElementById('cart-notification');
    if (!notif) return;

    var blockedEntry = status.entries.filter(function (e) {
      return e.qty > 0 && e.needed > 0;
    })[0];

    var msgEl = notif.querySelector('.moq-notice--notification');

    if (!blockedEntry) {
      if (msgEl) msgEl.remove();
      return;
    }

    if (!msgEl) {
      msgEl = document.createElement('div');
      msgEl.className = 'moq-notice moq-notice--notification';
      var anchor = notif.querySelector('#cart-notification-product');
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(msgEl, anchor.nextSibling);
      } else {
        notif.appendChild(msgEl);
      }
    }

    msgEl.innerHTML = barHTML(blockedEntry, 'notification');
  }

  function refresh() {
    // No MOQ rules apply on this page → never touch the cart/checkout UI at all,
    // so the feature is completely dormant until a product is tagged `moq-<n>`.
    if (!hasRules()) return Promise.resolve();
    return fetchCart().then(function (cart) {
      var status = computeStatus(cart);
      toggleCheckoutButtons(status.blocked);
      updateProductNotice(status);
      updateNotification(status);
    });
  }

  if (document.readyState !== 'loading') {
    refresh();
  } else {
    document.addEventListener('DOMContentLoaded', refresh);
  }

  // Dawn publishes this after add-to-cart and after cart quantity changes.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      // Let Dawn finish swapping its sections / opening the popup first.
      setTimeout(refresh, 60);
    });
  }
})();
